import { render, staticRenderFns } from "./UserDrawer.vue?vue&type=template&id=155a57a0&scoped=true&"
import script from "./UserDrawer.vue?vue&type=script&lang=js&"
export * from "./UserDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a57a0",
  null
  
)

export default component.exports